/*
 *
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import IntegrationTemplateCategory from './integration-template-category';
import IntegrationTemplateCategoryDetail from './integration-template-category-detail';
import IntegrationTemplateCategoryUpdate from './integration-template-category-update';
import IntegrationTemplateCategoryDeleteDialog from './integration-template-category-delete-dialog';

const IntegrationTemplateCategoryRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<IntegrationTemplateCategory />} />
    <Route path="new" element={<IntegrationTemplateCategoryUpdate />} />
    <Route path=":id">
      <Route index element={<IntegrationTemplateCategoryDetail />} />
      <Route path="edit" element={<IntegrationTemplateCategoryUpdate />} />
      <Route path="delete" element={<IntegrationTemplateCategoryDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default IntegrationTemplateCategoryRoutes;
